import { forwardRef } from "react";
import { combineFn } from "zeta-dom/util";
import { ChoiceFieldProps, classNames, toRefCallback, useFormField } from "zeta-dom-react";
import { IconNames } from "src/components/common";
import { Button } from ".";

export interface ToggleButtonGroupItem {
    value: string;
    label: string;
    icon?: IconNames;
}

export interface ToggleButtonGroupProps extends Omit<ChoiceFieldProps<ToggleButtonGroupItem>, 'onChange'>, Omit<React.ComponentPropsWithoutRef<'div'>, 'onChange'> {
    items: ToggleButtonGroupItem[];
    variant?: 'chip';
    allowUnselect?: boolean;
    onChange?: (value: string, index: number) => void;
}

export const ToggleButtonGroup = forwardRef<HTMLDivElement, ToggleButtonGroupProps>((props, ref) => {
    const onChange = (v: string): any => {
        return props.onChange?.(v, selectedIndex);
    };
    const { allowUnselect, onChange: _, ..._props } = props;
    const { value, error, setValue, elementRef, items, selectedIndex } = useFormField('choice', { ...props, onChange }, '');

    return (
        <div {..._props} ref={combineFn(elementRef, toRefCallback(ref))} className={classNames(props.className, 'eac-field eac-button-group', { 'has-error': !!error, variant: props.variant })}>
            {items.map(v => (
                <Button key={v.value} {...v} className={v.value === value ? 'active' : ''} onClick={() => setValue(allowUnselect && value === v.value ? '' : v.value)} />
            ))}
        </div>
    );
});
